import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { unstable } from '@broadleaf/admin-components';

import {
  ActionPropShape,
  ComponentPropShape
} from 'app/common/constants/CommonProps';

import { LocalStateShape } from 'app/oms/components/AuroraOrderView/prop-types';
import { useContextParams } from 'app/oms/components/ItemsOrderViewSection/components/FulfillmentCard/hooks';
import { AuroraPayInvoiceFetch } from 'app/oms/components/AuroraPayInvoiceFetch';

const { MetadataUtils } = unstable;
const { getAttribute } = MetadataUtils;

const FetchAuroraPayInvoice = ({
  actionDefinition,
  fulfillment,
  orderMetadata,
  orderState
}) => {
  const contextParams = useContextParams(
    orderMetadata,
    orderState,
    fulfillment
  );

  const isFleetAcct = get(contextParams, 'order.fleetAcct', false);
  const paymentGatewayType = get(contextParams, 'order.paymentGatewayType');
  const allowedStatuses = getAttribute(actionDefinition, 'allowedStatuses', []);
  const display =
    isFleetAcct &&
    paymentGatewayType === 'CORCENTRIC' &&
    (isEmpty(allowedStatuses) || allowedStatuses.includes(fulfillment.status));
  if (!display) {
    return null;
  }

  return (
    <AuroraPayInvoiceFetch
      actionDefinition={actionDefinition}
      contextParams={contextParams}
    />
  );
};

FetchAuroraPayInvoice.propTypes = {
  actionDefinition: ActionPropShape,
  fulfillment: PropTypes.object,
  orderMetadata: ComponentPropShape,
  orderState: LocalStateShape
};

export default FetchAuroraPayInvoice;
export { FetchAuroraPayInvoice };
